import { gettingStarted } from './privateCloudBusinessEditionSimplivityConfig';
export const pagesConfig = [...gettingStarted()];
